
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(397|450|642|856)|6((07|27|55|6)8|223|596|822|834)|1(018|270|646)|8(052|578|838)|39(06|58)|2512|5158|5282|7038)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
